( function( window, document, $ ) {
    'use strict';

    $( document ).ready( function() {
        var Utils = ( function() {
            // --------------------------------------------------
            // CLASS PROPERTIES
            // --------------------------------------------------
            var self = {};

            self.isInstantiated = false;
            self.ref = null;
            self.debugMode = ( window.location.href.indexOf( 'debug=true' ) !== -1 );
            self.domains = {};

            // --------------------------------------------------
            // CONSTRUCTOR
            // --------------------------------------------------
            function Utils() {
                if ( self.isInstantiated ) {
                    Utils.debug( 'Whoops, looks like an instance of the `Utils` class has already been created. Returning existing instance.' );
                } else {
                    self.isInstantiated = true;
                    self.ref = this;
                }

                return self.ref;
            }

            // --------------------------------------------------
            // CLASS METHODS
            // --------------------------------------------------
            Utils.debug = function( message, method ) {
                if ( self.debugMode ) {
                    message = ( typeof message === 'string' ) ? message : '';
                    method = ( typeof method === 'string' ) ? method : 'warn';

                    try {
                        console[ method ]( message );
                    } catch ( err ) {
                        console.log( message );
                    }
                }
            };

            // --------------------------------------------------
            // INSTANCE METHODS
            // --------------------------------------------------
            Utils.prototype.windowFreeze = function() {
                if ( self.windowPos ) {
                    Utils.debug( 'Whoops, looks like the window is already frozen' );
                } else {
                    self.windowPos = $( window ).scrollTop();

                    var bodyElem = $( 'body' );

                    bodyElem.css( 'position', 'fixed' );
                    bodyElem.css( 'top', ( -1 * self.windowPos ) + 'px' );
                    bodyElem.css( 'overflow-y', 'scroll' );
                }
            };

            Utils.prototype.windowUnfreeze = function() {
                if ( typeof self.windowPos !== 'number' ) {
                    Utils.debug( 'Whoops, looks like the window is not frozen' );
                } else {
                    var bodyElem = $( 'body ' );

                    bodyElem.css( 'position', '' );
                    bodyElem.css( 'top', '' );
                    bodyElem.css( 'overflow-y', '' );

                    $( window ).scrollTop( self.windowPos );

                    self.windowPos = null;
                }
            };

            Utils.prototype.registerDomain = function( domain, langCode, options ) {
                domain = ( domain && typeof domain === 'string' ) ? domain : null;
                langCode = ( langCode && typeof langCode === 'string' ) ? langCode : null;
                options = ( options && typeof options === 'object' ) ? options : {};

                if ( !domain || !langCode ) {
                    Utils.debug( 'Missing argument(s) for `registerDomain()`. Aborting.' );
                    return null;
                }

                if ( self.domains[ langCode ] && !options.force ) {
                    Utils.debug( 'Whoops, likes the language code has already been registered. To overwrite the currently registered domain, add `force: true` to the options argument.' );
                    return null;
                }

                var domainData = {
                    domain: domain,
                    langCode: langCode,
                    callback: options.callback || null,
                };

                self.domains[ langCode ] = domainData;

                return self.domains[ langCode ];
            };

            Utils.prototype.fetchDomainDataByLang = function( langCode ) {
                langCode = ( langCode && typeof langCode === 'string' ) ? langCode : null;

                if ( !langCode ) {
                    Utils.debug( '`.fetchDomainDataByLang()` invoked with missing or invalid argument(s): langCode' );
                    return null;
                }

                if ( !self.domains[ langCode ] ) {
                    Utils.debug( 'No data exists for the following `langCode`' + langCode );
                    return null;
                }

                return self.domains[ langCode ];
            };

            Utils.prototype.parseLangCode = function( langCode, delimiter ) {
                langCode = ( langCode && typeof langCode === 'string' ) ? langCode : null;
                delimiter = ( delimiter && typeof delimiter === 'string' ) ? delimiter : '-';

                if ( !langCode ) {
                    return null;
                }

                try {
                    return langCode.split( delimiter )[ 0 ];
                } catch ( err ) {
                    return null;
                }
            };

            Utils.prototype.checkDomainLang = function() {
                if ( !window.navigator || !window.navigator.language ) {
                    Utils.debug( 'Browser does not support the `navigator` API. Aborting `checkDomainLang()`' );
                    return;
                }

                if ( Object.keys( self.domains ).length === 0 ) {
                    Utils.debug( 'No domains have been registered. Aborting `checkDomainLang()`.' );
                    return;
                }

                var langCode = this.parseLangCode( window.navigator.language );
                var domainData = this.fetchDomainDataByLang( langCode );

                if ( domainData.domain !== window.location.host ) {
                    Utils.debug( 'Current domain does not match domain registered for language code: ' + langCode );

                    if ( domainData.callback && typeof domainData.callback === 'function' ) {
                        domainData.callback();
                    }
                }
            };

            // --------------------------------------------------
            // PUBLIC API
            // --------------------------------------------------
            return Utils;
        } )();

        // Expose class and instance refs.
        window.Utils = Utils;
        window.utilsRef = new Utils();

    } );
} )( window, document, jQuery );
